module.exports = __webpack_public_path__ + "static/media/st.3f91fe6b.jpeg";